import axios from 'axios';
import { addTrailingSlash } from '../../utils/url';

export class ApiRequest {
  constructor(args) {
    Object.assign(this, args);
    this.isCritical = true;
  }

  batch(batcher) {
    this.batcher = batcher;
    return this;
  }

  setCritical(value) {
    this.isCritical = value;
    return this;
  }
}

const isDataMethod = method => ['post', 'put', 'patch'].includes(method);

const createRequest = (method, request, data = undefined, options = {}) => {
  const config = (
    typeof request === 'string'
      ? { ...options, url: addTrailingSlash(request), data }
      : { ...request, url: addTrailingSlash(request.url) }
  );

  return new ApiRequest({ method, ...config });
};

const createRequestObject = method => (url, data, options = {}) => (
  isDataMethod(method)
    ? createRequest(method, url, data, options)
    : createRequest(method, url, undefined, data)
);

const axiosMethods = Object.keys(axios.create({
  baseURL: `${
    (typeof window === 'object' && window.mendeley && window.mendeley.baseURL) ||
    (typeof global === 'object' && global.baseURL)
  }api/`
}));

export default axiosMethods.reduce((api, method) => ({
  ...api,
  [method]: createRequestObject(method)
}), {});



// WEBPACK FOOTER //
// ./src/universal/ui/services/api/request.js